export default "__VITE_ASSET__BWkYnGZx__"